import React from 'react';
import { ButtonWrapper, Button } from './ExportButton.styles';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { basePath } from '../../../../services/utils';
export const EXPORT_TYPES = {
    EXCEL: 'EXCEL',
    PPT: 'PPT',
    PDF: 'PDF',
};

const ExportButton = ({
    type,
    getExportLinkActionCreator,
    exportDisabled,
    customStyle,
    setLoading,
    isTextButton,
    text,
}) => {
    const location = useLocation();

    let icon;
    switch (type) {
        case EXPORT_TYPES.EXCEL:
            icon = `${basePath}/visuals/CSV_icon_export.svg`;
            break;
        case EXPORT_TYPES.PPT:
            icon = `${basePath}/visuals/PPT_export_icon.svg`;
            break;
        case EXPORT_TYPES.PDF:
            icon = `${basePath}/visuals/PDF_export_icon.svg`;
            break;
        default:
            break;
    }
    return isTextButton ? (
        <Button
            onClick={() => {
                !exportDisabled && getExportLinkActionCreator({ path: location.pathname });
            }}
            disabled={exportDisabled}
        >
            <p>{text}</p>
        </Button>
    ) : (
        <ButtonWrapper
            customStyle={customStyle?._wrapper}
            onClick={() => {
                // setLoading && setLoading(true); DFE-2074
                !exportDisabled &&
                    getExportLinkActionCreator({ path: location.pathname, exportTypeOverwrite: type.toLowerCase() });
            }}
            // getExportLinkActionCreator({
            //     path: location.pathname,
            //     exportTypeOverwrite: type.toLowerCase(),
            // });
            //}} DFE-2074
            exportDisabled={exportDisabled}
        >
            <img src={icon} alt={`Export Button ${type}`} />
        </ButtonWrapper>
    );
};
ExportButton.propTypes = {
    type: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]),
    getExportLinkActionCreator: PropTypes.func.isRequired,
    customStyle: PropTypes.object,
    isTextButton: PropTypes.bool,
    text: PropTypes.string,
    //  setLoading: PropTypes.func, DFE-2074
};
export default ExportButton;
